import {combineReducers} from "redux";
import vnOne from "./vnOne";


const orderBettingReducer = combineReducers({
    vnOne
});
export default orderBettingReducer;